import { Avatar } from '@/components/Avatar'
import { FormGroup } from '@/components/Form'
import {
  CustomSelect,
  SingleItemSelectedDefault,
} from '@/components/inputs/CustomSelect'
import { useCustomSelectStateFromInfiniteScrollProvider } from '@/components/inputs/infinite-scroll-provider-hook'
import { SearchResultItem } from '@/components/inputs/SearchResultItem'
import { observer } from 'mobx-react-lite'
import { type LegendSelectorViewModel } from '@/features/jobs/drafting/LegendSelectorViewModel'
import { type PublishedLegend } from '@/features/jobs/legends/PublishedLegend'

export interface CompactLegendSelectorContainerProps {
  vm: LegendSelectorViewModel
  isDisabled?: boolean
  searchResults?: PublishedLegend[]
}

export const CompactLegendSelectorContainer = observer(
  function CompactLegendSelectorContainer({
    vm,
    isDisabled,
    searchResults,
  }: CompactLegendSelectorContainerProps) {
    const selectProps = useCustomSelectStateFromInfiniteScrollProvider({
      scrollProvider: vm.scroller,
      searchResults: searchResults ?? vm.filteredLegends,
      searchText: vm.searchText,
      onSearchTextChange: vm.setSearchText,
    })

    return (
      <FormGroup>
        <CustomSelect
          {...selectProps}
          placeholder="Select a legend"
          itemToString={(v) => String(v?.name)}
          focus$={vm.step.becomeActive$}
          onFocus={vm.step.onBecameActive}
          isDisabled={isDisabled ?? vm.disabled}
          value={vm.selectedLegendVersion ?? undefined}
          onChange={vm.selectLegend}
          multi={false}
          testId="compact-legend-selector"
          renderItem={(itemProps) => (
            <SingleItemSelectedDefault
              visual={
                <Avatar
                  size={24}
                  subject={{
                    displayName: itemProps.item.name,
                    avatar: itemProps.item.imageUrl,
                  }}
                />
              }
              {...itemProps}
            />
          )}
          renderSearchItem={({
            item,
            itemToString: _itemToString,
            ...itemProps
          }) => (
            <SearchResultItem
              {...itemProps}
              visual={
                <Avatar
                  size={24}
                  subject={{
                    avatar: item.imageUrl,
                    displayName: item.name,
                  }}
                />
              }
            >
              {item.name}
            </SearchResultItem>
          )}
        />
      </FormGroup>
    )
  },
)
